export default __webpack_public_path__ + "static/media/gallery03.6293de79.webp";